export default __webpack_public_path__ + "static/media/yeopen_medium.a51bbe26.jpg";